export default () => ({
  configs: [],
})
